var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "f59e9deda4c9b35ff4c9a17916fecfc1b07b3a34"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-ca@rodi"] = {
  id: "f59e9deda4c9b35ff4c9a17916fecfc1b07b3a34"
};